export default __webpack_public_path__ + "static/media/eventscroller.9188b248.png";